// extracted by mini-css-extract-plugin
var _1 = "flagWrapper___nZrQS";
export { _1 as "flagWrapper" }
